module.exports = __webpack_public_path__ + "src/img/greyCloseIcon.4b0cd68c.svg";